module.exports = require('./helpers/bundle-url').getBundleURL('bVFEr') + "logo-dark.ba5147f0.svg";